export enum OrganisationSelectorEventTypeEnum {
  SelectorClosed,
  OpenSelector,
  OrganisationSelected,
  AssociateOrganisationSelected,
  DeploySupplierSelected,
  OpenAddNumberSelector,
  AssociateUserSelected,
  OpenUserSelector,
  CloseUserSelector,
  AddNumberSelectorClosed,
}
